import { FetchContext } from '../fetch-context';
import { QuestionnaireQuestionRef } from '../../models';
import { responseErrorHandler } from '../response-error-handler';

export const updateQuestionnaire: (
  fetchContext: FetchContext,
  questionnaireId: number,
  questionnaireQuestionRef: QuestionnaireQuestionRef,
  accessToken?: string,
) => Promise<void> = (fetchContext, questionnaireId, questionnaireQuestionRef, accessToken) => {
  return fetch(`${fetchContext.baseUrl}/api/questionnaires/${questionnaireId}`, {
    method: 'PUT',
    headers: {
      Authorization: `Bearer ${accessToken}`,
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(questionnaireQuestionRef),
  }).then((response) => responseErrorHandler<void>(fetchContext.errorStore, response, 'update questionnaire'));
};
